export default {
  LOAD_STUDY_PROGRAM_SKILL_ABILITY_FORM_PAGE_START: 'LoadStudyProgramSkillAbilityFormPageStart',
  LOAD_STUDY_PROGRAM_SKILL_ABILITY_FORM_PAGE_END: 'LoadStudyProgramSkillAbilityFormPageEnd'
};